<div
  class="radio-group"
  [ngClass]="{ 'radio-group-vertical': layout === 'vertical' }"
>
  <div class="radio-option" *ngFor="let option of options">
    <ot-radio
      [value]="option"
      [checked]="isChecked(option)"
      (select)="onSelect($event)"
      [disabled]="disabled"
    >
      {{ option }}
    </ot-radio>
  </div>
</div>
